export default  {
    list: [],
    load: true,
    dataUploaded: false,
    error: false,
    errorText: '',
}